module.exports = __webpack_public_path__ + "static/cover-795ee986e11191d8a5284e8d2cbebc63.png";